import { faFacebook, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faFaceAngry, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
function Footer(){
 
return(

<div>
<footer>
  <div class="footer bg-dark" >
    <div class="container pt-4">




      <div class=" d-flex  justify-content-between ">
        <div class="">
          <h4 class="text-uppercase text-white">Quick Links</h4>
          <ul class="list-group">
            <li><a href="" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Home</a></li>
            <li><a href="https://www.bhargavastropoint.com/" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Best Jyotish In Palam Viharg Gurgoan</a></li>
            <li><a href="https://www.jyotishexpert.com/" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Famous Astrologer Gurgaon</a></li>
            <li><a href="https://www.astrologergurgaon.com/astrologer-sector-110-gurugram/" class="text-white text-uppercase text-decoration-none d-inline-block ft-link">Astrologer In New Plam Vihar Gurgaon</a></li>
          </ul>
        </div>
        <div className="text-wrap">
          <h4 class="text-uppercase text-white">Services</h4>
          <ul class="ps-0 mt-4 mb-0 ft-list-texts">
            <li><a href="https://www.astrologergurgaon.com/articals/" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Articles</a></li>
            <li><a href="https://www.astrologergurgaon.com/zodiaczone/" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Zodiac Zone</a></li>
            <li><a href="https://www.jyotishexpert.com/products/" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Asto Shopping</a></li>
            <li><Link to="/relationship" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Marriage Problem in Kundali</Link></li>
            <li><Link to="/Career-Guidance" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Career Astrology</Link></li>
            <li><Link to="/kundalimatching" class="text-white text-uppercase text-decoration-none mb-2 d-inline-block ft-link">Kundali Matching</Link></li>
            <li><Link to="/kundalianalysis" class="text-white text-uppercase text-decoration-none d-inline-block ft-link">Horoscopes Reading</Link></li>
          </ul>
        </div>
        <div className="text-wrap w-25">
          <h4 className="text-uppercase text-white">About us</h4>
          <div className="mt-4 text-wrap">
            <p className="text-white text-wrap text-break">Famous astrologer Sanjay Bhargav, based in Gurgaon, has garnered a reputation for his 25 years of expertise in Vedic astrology. With a keen insight into life's mysteries, he offers precise predictions and personalized guidance on career, relationships, health, and more. Sanjay Bhargav is considered one of the top astrologers in Gurgaon, seamlessly blending ancient wisdom with modern techniques to help individuals find clarity and direction.</p>
          </div>
        
          <ul className="ps-0 mt-4 mb-0 d-flex gap-3 ft-socials">
            <li className="text-white">Follow us</li>
            <li><a href="https://www.facebook.com/jyotishexpert" class="text-white text-uppercase text-decoration-none d-inline-block ft-social-link fb"><FontAwesomeIcon icon={faFacebook}></FontAwesomeIcon></a></li>
            <li><a href="https://www.youtube.com/@bhargavastropoint" class="text-white text-uppercase text-decoration-none d-inline-block ft-social-link youtube"><FontAwesomeIcon icon={faYoutube}></FontAwesomeIcon></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="copyright-box py-3" style={{background:'black'}}>
    <p class="w-100 text-center text-white mb-0">© 2025 Bhargav Astro Point all right reserved</p>
  </div>
</footer>
</div>
)


}


export { Footer};

